import React from "react";
import Navbar from "../components/navbar/navbar";
import Project from "../components/project/project";
import Footer from "../components/footer/footer";

const Spoat: React.FC = () => {


  return (
    <>
      <Navbar/>
      <div className="page-content">
        <Project project="spoat"/>
      </div>
      <Footer />
    </>
  );
};

export default Spoat;